// extracted by mini-css-extract-plugin
export default {"img-container":"BlogContent_img-container__S1BZF","title":"BlogContent_title__B8txa"};